/* eslint-disable @typescript-eslint/no-unused-vars */
import PoseBase from "./PoseBase";

export default class PoseConstraints extends PoseBase {

  public constraintPositionX?: number;
  public constraintPositionY?: number;
  public constraintPositionZ?: number;

  constructor() {
    super();
  }

  public override update() {
    if( this.constraintPositionX ) {
      this.position.x = this.constraintPositionX;
    }
    if( this.constraintPositionY ) {
      this.position.y = this.constraintPositionY;
    }
    if( this.constraintPositionZ ) {
      this.position.z = this.constraintPositionZ;
    }
  }

  public override reset() {
    super.reset();
    this.constraintPositionX = undefined;
    this.constraintPositionY = undefined;
    this.constraintPositionZ = undefined;
  }
}